import { defineServerNegotiator } from "../helpers/defineServerNegotiator.js";
import {
  defaultLanguageNoPrefix,
  defaultLangcode,
  prefixToLangcode
} from "#nuxt-language-negotiation/config";
export default defineServerNegotiator(() => {
  return {
    negotiate(event) {
      const matches = /\/([^/]+)/.exec(event.path);
      const prefix = matches?.[1];
      if (prefix) {
        const langcode = prefixToLangcode[prefix];
        if (langcode) {
          return langcode;
        }
      }
      if (defaultLanguageNoPrefix) {
        return defaultLangcode;
      }
    }
  };
});
